import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { RocketLaunch, ArrowRight, Ticket, X, CheckCircle } from "@phosphor-icons/react";
import { registerUpgradeHandler } from "@/lib/api";

const PERKS = [
  "Unlimited grants & receipts",
  "Payslip & invoice PDFs",
  "Certificates, exports & scheduled reports",
];

/* Global one-click upgrade prompt. The API interceptor calls the registered
   handler on any 402 (limit / Pro-gated) so the whole app shares one branded
   modal instead of a native browser alert(). */
export default function UpgradeModal() {
  const [msg, setMsg] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    registerUpgradeHandler((m) => setMsg(m || "Upgrade to Pro to unlock this."));
    return () => registerUpgradeHandler(null);
  }, []);

  const close = () => setMsg(null);
  const goBilling = () => { setMsg(null); navigate("/billing"); };

  return (
    <AnimatePresence>
      {msg && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          onClick={close}
          className="fixed inset-0 z-[9999] bg-black/75 backdrop-blur-sm flex items-center justify-center p-4"
          data-testid="upgrade-modal"
        >
          <motion.div
            initial={{ y: 24, opacity: 0, scale: 0.97 }} animate={{ y: 0, opacity: 1, scale: 1 }} exit={{ y: 24, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
            className="glass rounded-2xl w-full max-w-md p-8 relative"
            style={{ background: "rgba(10,19,17,0.96)", border: "1px solid rgba(255,176,32,0.35)" }}
          >
            <button onClick={close} data-testid="upgrade-modal-close" className="absolute top-5 right-5 text-white/45 hover:text-white"><X size={20} /></button>

            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{ background: "#FFB020" }}>
              <RocketLaunch size={26} weight="fill" color="#050B0A" />
            </div>

            <div className="eyebrow mb-1" style={{ color: "#FFB020" }}>Upgrade to Pro</div>
            <div className="font-display text-2xl mb-2">You&apos;ve hit a Free-plan limit</div>
            <p className="text-sm text-white/60 leading-relaxed mb-5" data-testid="upgrade-modal-msg">{msg}</p>

            <div className="space-y-2 mb-6">
              {PERKS.map((p) => (
                <div key={p} className="flex items-center gap-2.5 text-sm text-white/75">
                  <CheckCircle size={16} weight="fill" style={{ color: "#00A86B" }} /> {p}
                </div>
              ))}
            </div>

            <button onClick={goBilling} data-testid="upgrade-modal-go" className="btn-gold w-full justify-center mb-3">
              Upgrade to Pro <ArrowRight size={16} weight="bold" />
            </button>
            <button onClick={goBilling} data-testid="upgrade-modal-code" className="btn-ghost w-full justify-center text-sm">
              <Ticket size={15} weight="fill" /> Have an accelerator access code?
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
